import { useUserStore } from "@/stores/user";
import { createRouter, createWebHistory } from "@ionic/vue-router";
import { supabase } from "../lib/supabaseClient";
import TabsPage from "../views/TabsPage.vue";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: () => import("@/views/SignUpPage.vue"),
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () => import("@/views/ForgotPasswordPage.vue"),
  },
  {
    path: "/update-password",
    name: "Update Password",
    component: () => import("@/views/UpdatePasswordPage.vue"),
  },
  {
    path: "/",
    component: TabsPage,
    children: [
      {
        path: "",
        redirect: "/dashboard",
      },
      {
        path: "recommendations",
        component: () => import("@/views/RecommendationsPage.vue"),
      },
      // {
      //   path: "new",
      //   component: () => import("@/views/Tab2Page.vue"),
      // },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/DashboardPage.vue"),
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("@/views/SettingsPage.vue"),
      },
    ],
  },
  {
    path: "/recommendations/:id",
    name: "RecommendationDetail",
    component: () => import("@/views/RecommendationDetailPage.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/AboutPage.vue"),
  },
  {
    path: "/help",
    name: "Help",
    component: () => import("@/views/HelpPage.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/PrivacyPage.vue"),
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import("@/views/TermsPage.vue"),
  },
  {
    path: "/delete-account",
    name: "Delete Account",
    component: () => import("@/views/DeleteAccountPage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  const userStore = useUserStore();
  if (!userStore.user) {
    const { data, error } = await supabase.auth.getUser();
    // console.log(data, error);
    // if (error) {
    //   location.href = "/login";
    // }
    if (data.user) {
      userStore.user = { ...data.user, uid: data.user.id };
      if (!data.user.user_metadata?.language) {
        await supabase.auth.updateUser({
          data: { language: "de" },
        });
      }
    }
  }
  if (
    userStore.user &&
    ["Login", "Sign Up", "Forgot Password"].includes(to.name)
  ) {
    return "/";
  }
});

export default router;
